const state = {
    users: {},
    members: {},
    groups: {},
    permissions: {},
    sections: {},
    types: {},
    suppliers: {},
    applicationForms: {},
    news: {},
    submissions: {},
    supplierSubmissions: {},
    templates: {},
    tasks: {}
};

const getters = {
    filters: state => {
        return state;
    }
}

const mutations = {
    SET_FILTERS (state, payload){
        state[payload.resource] = payload.data;
    }
}

const module = {
    state,
    mutations,
    getters
};

export default module;
